export const loadPostPage = () => import('../pages/Post');

export const preloadPostPage = () => {
  loadPostPage();
};
